import { Affordability } from '@/service';

/**
 * @class @name AffordabilityStore
 * @description Exposes menu store module
 */
export default class AffordabilityStore {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name fetchAffordabilityList
			 * @param {function} commit
			 * @param {Object} payload
			 */
			fetchAffordabilityList(context, payload) {
				return Affordability.list(payload);
			},

			/**
			 * @async @name submitAffordability
			 * @param {Object} context
			 * @param {Object} payload
			 */
			submitAffordability(context, payload) {
				return Affordability.post(payload);
			},

			/**
			 * @async @name markAsCompleted
			 * @param {Object} context
			 * @param {Object} payload
			 */
			markAsCompleted(context, payload) {
				return Affordability.patch(payload);
			},

			/**
			 * @async @name fetchAffordabilityList
			 * @param {function} commit
			 * @param {Object} payload
			 */
			fetchAffordabilityFile(context, payload) {
				return Affordability.get(payload);
			}
		};
	}
}
